/**
 * @internal
 */
export class AttrJsonLanguage {
  // ReSharper disable InconsistentNaming
  Current: string;
  Primary: string;
  All: string[] | null;
  // ReSharper restore InconsistentNaming
}
